import { gql } from '@apollo/client';

// TRIL-394: direct-message operations. Authored with Apollo's `gql` tag for now
// (untyped); codegen migration to graphql() is a follow-on once the shape settles.

export const GET_MY_CONVERSATIONS = gql`
  query myConversations($limit: Int, $cursor: String) {
    myConversations(limit: $limit, cursor: $cursor) {
      conversations {
        convId
        otherUserId
        otherUser {
          id
          username
          avatar
          online
        }
        lastMessageAt
        preview
        unreadCount
        saved
      }
      nextCursor
    }
  }
`;

export const GET_CONVERSATION = gql`
  query conversation($convId: String!, $limit: Int, $cursor: String) {
    conversation(convId: $convId, limit: $limit, cursor: $cursor) {
      convId
      messages {
        convId
        messageId
        senderId
        body
        createdAt
      }
      nextCursor
    }
  }
`;

export const SEND_DIRECT_MESSAGE = gql`
  mutation sendDirectMessage($recipientId: String!, $body: String!) {
    sendDirectMessage(recipientId: $recipientId, body: $body) {
      convId
      messageId
      senderId
      body
      createdAt
    }
  }
`;

export const MARK_CONVERSATION_READ = gql`
  mutation markConversationRead($convId: String!) {
    markConversationRead(convId: $convId) {
      convId
      unreadCount
    }
  }
`;

export const DELETE_CONVERSATION = gql`
  mutation deleteConversation($convId: String!) {
    deleteConversation(convId: $convId) {
      convId
      deleted
    }
  }
`;

export const SEND_TYPING_INDICATOR = gql`
  mutation sendTypingIndicator($recipientId: String!) {
    sendTypingIndicator(recipientId: $recipientId)
  }
`;
